module.exports = __webpack_public_path__ + "images/fbb4e9997a6909e7e41485be8c24152f.png";